import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import {useContext, useEffect, useState} from "react";
import {displayPhone, handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";

export default function ManageVendorModal({vendor, handleClose, handleSave, show}) {

  const [context, setContext] = useContext(AppContext);
  const [formInvalid, setFormInvalid] = useState(false);

  const [saving, setSaving] = useState(false);
  const [isNew, setIsNew] = useState(vendor?.guid != null);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(vendor)
  });

  const handleModalClose = () => {
    handleClose();
  };

  useEffect(() => {
    setSaving(false);
  }, [show]);

  const handleFormSave = (data) => {
    setSaving(true);
    handleSave(data);
  };


  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form onSubmit={handleSubmit(handleFormSave)} id={'brandForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Vendor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off" required
                        InputLabelProps={{shrink: true}}
                        {...register('firstName')}
                        autoComplete="off"
                        className="form-control" id="firstName"
                        label="First Name"
                        placeholder="Enter First Name"/>

                    </div>
                  </Col>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off" required
                        InputLabelProps={{shrink: true}}
                        {...register('lastName')}
                        autoComplete="off"
                        className="form-control" id="lastName"
                        label="Last Name"
                        placeholder="Enter Last Name"/>

                    </div>
                  </Col>
                </Row>
                <Row className={'mt-4'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        {...register('companyName')}
                        autoComplete="off"
                        label="Company"
                        className="form-control" id="companyName"
                        placeholder="Enter Company Name"/>

                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        {...register('phone', {
                          onChange: (e) => {
                            e.target.value = displayPhone(e.target.value);
                          }
                        })}
                        autoComplete="off"
                        className="form-control" id="phone"
                        label="Phone"
                        placeholder="Enter Phone"/>

                    </div>
                  </Col>
                </Row>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        {...register('email')}
                        autoComplete="off"
                        className="form-control" id="email"
                        placeholder="Enter Email"
                        label="Email"/>

                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        {...register('website')}
                        autoComplete="off"
                        className="form-control" id="website"
                        label="Website"
                        placeholder="Enter Website"/>

                    </div>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <label>Notes</label>
                      <textarea
                        rows={5}
                        {...register('notes')}
                        className="form-control" id="notes"
                        placeholder="Enter Notes"/>

                    </div>
                  </Col>
                </Row>


              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}